import React, { useState, useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import { AUTOCOMPLETE_MIN_VALUE_LENGTH, AUTOCOMPLETE_DELAY_TIME } from '../../../search-trip/consts/data'
import { fetchApartmentAutocomplete } from '../../api/fetchApartmentAutocomplete'

const DestinationsApartmentFilter = ({
    placeholder,
    toggleFilterMode,
    onFilterHandle,
    onLoading,
    onHotelsChange,
    resetTrigger,
    destinations,
    selectedDestination
}) => {
    const [inputValue, setInputValue] = useState(selectedDestination || '')
    const [errorMessage, setErrorMessage] = useState(null)

    const debounceRef = useRef(null)
    const latestQueryRef = useRef('')

    const clearDebounceTimeout = () => {
        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
            debounceRef.current = null;
        }
    };

    const resetHotels = () => {
        onHotelsChange([]);
        onLoading(false);
    };

    const searchHandler = (event) => {
        const rawValue = event.target.value;
        const query = rawValue.toLowerCase();

        setInputValue(rawValue)
        toggleFilterMode(true);
        latestQueryRef.current = query;

        clearDebounceTimeout()

        if (query.length === 0) {
            setErrorMessage(null);
            toggleFilterMode(false);
            resetHotels();

            return;
        }

        if (query.length < AUTOCOMPLETE_MIN_VALUE_LENGTH) {
            setErrorMessage(`Minimum ${AUTOCOMPLETE_MIN_VALUE_LENGTH} znaki`);
            toggleFilterMode(false);
            resetHotels();

            return;
        }

        setErrorMessage(null);
        toggleFilterMode(true);
        onLoading(true);

        const filtered = destinations.filter(item =>
            item.toLowerCase().includes(query)
        );
        onFilterHandle(filtered);

        const fetchQuery = latestQueryRef.current;

        debounceRef.current = setTimeout(() => {
            fetchApartmentAutocomplete(fetchQuery)
                .then(hotels => {
                    if (latestQueryRef.current !== fetchQuery) return;

                    onHotelsChange(hotels);
                })
                .catch(err => {
                    if (latestQueryRef.current !== fetchQuery) return;

                    setErrorMessage(err.message);
                    onHotelsChange([]);
                })
                .finally(() => {
                    if (latestQueryRef.current === fetchQuery) {
                        onLoading(false)
                    }
                })
        }, AUTOCOMPLETE_DELAY_TIME)
    }

    useEffect(() => {
        setInputValue('');
        setErrorMessage(null);

        toggleFilterMode(false);
        latestQueryRef.current = '';

        clearDebounceTimeout();

        return () => {
            clearDebounceTimeout();
        };
    }, [resetTrigger, toggleFilterMode])

    useEffect(() => {
        if (selectedDestination && inputValue === '') {
            setInputValue(selectedDestination);
        }
    }, [selectedDestination])

    return (
        <div className="destinations-apartment-filter">
            <input
                type="search"
                placeholder={placeholder}
                value={inputValue}
                aria-describedby="basic-addon1"
                onChange={searchHandler}
            />
            {errorMessage && <span>{errorMessage}</span>}
        </div>
    )
}

const mapStateToProps = (state) => ({
    destinations: state.formReducer.citiesList,
})

export default connect(mapStateToProps)(DestinationsApartmentFilter)
